import { faCalendarCheck, faClock } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import { useUserInfor } from "../../../../../Context/User";
import DisponibilidadeVistoria from "../../../../../Pages/VistoriaEntregaDeChaves/DisponibilidadeVistoria";
import { ACESSOS } from "../../../../../Routes/Acessos";
import { mostrarNavDeTela } from "../../../../../Validations/UsuarioTela";
import { IComponentModal } from "../../../../Modais/IModalComponent";
import ModalSubNav from "../../../../../Components/Modais";
import { NavLink } from "react-router-dom";
import DisponibilidadeVistoriaEmMassa from "../../../../../Pages/VistoriaEntregaDeChaves/DisponibilidadeVistoriaEmMassa";

export function SubNavGestaoCadastroVistoria() {
    const { UserInfor } = useUserInfor();

    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    return (
        <>
            {mostrarNavDeTela(
                ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_CADASTRO
                    .DISPONIBILIDADE_VISTORIA.ID_TELA,
                UserInfor.TELAS
            ) && (
                <li className="menu-item">
                    <a
                        href="#/"
                        className="menu-link"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                Component: () => {
                                    return (
                                        <DisponibilidadeVistoria
                                            setShow={setShow}
                                        />
                                    );
                                },
                                size: "xl",
                                IconHeader: faCalendarCheck,
                                headerComponent: "Disponibilidade Vistoria",
                            });
                        }}
                    >
                        <span className="svg-icon menu-icon">
                            <FontAwesomeIcon icon={faCalendarCheck} />
                        </span>
                        <span className="menu-text">
                            Disponibilidade Vistoria
                        </span>
                    </a>
                </li>
            )}
            {mostrarNavDeTela(
                ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_CADASTRO
                    .DISPONIBILIDADE_VISTORIA.ID_TELA,
                UserInfor.TELAS
            ) && (
                <li className="menu-item">
                    <a
                        href="#/"
                        className="menu-link"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                Component: () => {
                                    return <DisponibilidadeVistoriaEmMassa />;
                                },
                                size: "xl",
                                IconHeader: faCalendarCheck,
                                headerComponent:
                                    "Disponibilidade Vistoria Em Massa",
                            });
                        }}
                    >
                        <span className="svg-icon menu-icon">
                            <FontAwesomeIcon icon={faCalendarCheck} />
                        </span>
                        <span className="menu-text">
                            Disponibilidade Vistoria Em Massa
                        </span>
                    </a>
                </li>
            )}
            {mostrarNavDeTela(
                ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_CADASTRO
                    .HORARIOS_DISPONIVEIS.ID_TELA,
                UserInfor.TELAS
            ) && (
                <li className="menu-item">
                    <NavLink
                        to={
                            ACESSOS.ENTREGA_DE_CHAVES.TELAS.GESTAO_CADASTRO
                                .HORARIOS_DISPONIVEIS.DS_PATH
                        }
                        exact
                        activeClassName="active"
                        className="menu-link"
                    >
                        <span className="svg-icon menu-icon">
                            <FontAwesomeIcon icon={faClock} />
                        </span>
                        <span className="menu-text">Horários Disponíveis</span>
                    </NavLink>
                </li>
            )}
            <ModalSubNav show={show} setShow={setShow} ModalComponent={modal} />
        </>
    );
}
